import React from 'react';
import PropTypes from 'prop-types';

import { Container, Actions } from './styles';

function DashboardTitle({ title, children }) {
  return (
    <Container>
      <h1>{title}</h1>
      <Actions>{children}</Actions>
    </Container>
  );
}

DashboardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default DashboardTitle;
